import React, { useState, useEffect } from "react";

const PreviousComplaint = ({ previousComplaintsData }) => {
    const [showModal, setShowModal] = useState(false);
    const [activeComplaint, setActiveComplaint] = useState(null);

    const openModal = (complaint) => {
        setActiveComplaint(complaint);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setActiveComplaint(null);
    };



    return (
        <>
            {/* ================= TABLE ================= */}
            <h4 className="mt-4" style={{ textAlign: "center" }}>Previous Complaints</h4>

            <div className="table-responsive tenders-table">
                <table className="table table-bordered align-middle complaint-table">
                    <thead>
                        <tr>
                            <th>SL.NO</th>
                            <th>Acknowledgement No</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th width="120">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {previousComplaintsData.map((item, index) => (
                            <tr key={index}>
                                <td>{index+1}</td>
                                <td className="complaint-id">{item.complaint_id}</td>
                                <td>{item.date}</td>
                                <td>{item.complaint_status}</td>
                                <td>
                                    <button
                                        className="view-btn-file"
                                        onClick={() => openModal(item)}
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* ================= MODAL ================= */}
            {showModal && activeComplaint && (
                <div className="complaint-modal-overlay">
                    <div className="complaint-modal">

                        <div className="modal-header">
                            <div>
                                <h5>{activeComplaint.complaint_id}</h5>
                                <small>{activeComplaint.date}</small>
                            </div>
                            <button onClick={closeModal}>✖</button>
                        </div>

                        <div className="modal-body">

                            {/* BASIC */}
                            <div className="section">
                                <h6>Basic Information</h6>
                                <div className="grid-2">
                                    <p><b>Status:</b> {activeComplaint.complaint_status}</p>
                                    <p><b>District:</b> {activeComplaint.district}</p>
                                </div>
                            </div>

                            {/* COMPLAINANT */}
                            <div className="section">
                                <h6>Complainant Details</h6>
                                <div className="grid-2">
                                    <p><b>Name:</b> {activeComplaint.fullname}</p>
                                    <p><b>Email:</b> {activeComplaint.email}</p>
                                    <p><b>Phone:</b> {activeComplaint.phone}</p>
                                    <p><b>Address:</b> {activeComplaint.address}</p>
                                </div>
                            </div>

                            {/* INCIDENT */}
                            <div className="section">
                                <h6>Incident Details</h6>
                                <div className="grid-2">
                                    <p><b>From:</b> {activeComplaint.date_incident_from}</p>
                                    <p><b>To:</b> {activeComplaint.date_incident_to}</p>
                                    <p><b>Place:</b> {activeComplaint.place}</p>
                                </div>

                                <div className="description-box">
                                    {activeComplaint.description}
                                </div>
                            </div>

                            {/* EVIDENCE */}
                            {activeComplaint.evidence?.length > 0 && (
                                <div className="section">
                                    <h6>Evidence</h6>
                                    <div className="evidence-grid">
                                        {activeComplaint.evidence.map((img, i) => (
                                            <a key={i} href={img} target="_blank" rel="noreferrer">
                                                <img src={img} alt="evidence" />
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* SUSPECTS */}
                            {activeComplaint.suspects?.length > 0 && (
                                <div className="section">
                                    <h6>Suspect Details</h6>
                                    {activeComplaint.suspects.map((s, i) => (
                                        <div key={i} className="suspect-card">
                                            <p><b>Name:</b> {s.name || "N/A"}</p>
                                            <p><b>Designation:</b> {s.designation}</p>
                                            <p><b>Department:</b> {s.department}</p>
                                            <p><b>Office:</b> {s.office_name}</p>
                                            <p><b>District:</b> {s.district}</p>
                                            <p><b>Other Info:</b> {s.other_information}</p>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PreviousComplaint;
